var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57732 2.0003L14.928 13.0003C14.9865 13.1016 15.0173 13.2166 15.0173 13.3336C15.0173 13.4506 14.9865 13.5656 14.928 13.667C14.8695 13.7683 14.7853 13.8525 14.684 13.911C14.5826 13.9695 14.4677 14.0003 14.3506 14.0003H1.64932C1.53229 14.0003 1.41733 13.9695 1.31599 13.911C1.21464 13.8525 1.13049 13.7683 1.07198 13.667C1.01347 13.5656 0.982665 13.4506 0.982666 13.3336C0.982667 13.2166 1.01347 13.1016 1.07198 13.0003L7.42265 2.0003C7.48116 1.89896 7.56532 1.81481 7.66666 1.7563C7.76801 1.69779 7.88296 1.66699 7.99998 1.66699C8.117 1.66699 8.23196 1.69779 8.3333 1.7563C8.43464 1.81481 8.5188 1.89896 8.57732 2.0003ZM7.33332 10.667V12.0003H8.66665V10.667H7.33332ZM7.33332 6.0003V9.33363H8.66665V6.0003H7.33332Z",
    fill: "#AD3737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.9143b91ea7901d523f20b16f8f0c6c10.svg";
export { ForwardRef as ReactComponent };